'use client';

import { FulfillmentOptions } from '@libs/shared-ui';

import { BopisDeliveryTile } from './BopisDeliveryTile';
import { SddDeliveryTile } from './SddDeliveryTile';
import { SthDeliveryTile } from './SthDeliveryTile';

export const DeliveryOptions = () => {
    return (
        <FulfillmentOptions data-testid="pdp-delivery-options">
            <BopisDeliveryTile />
            <SddDeliveryTile />
            <SthDeliveryTile />
        </FulfillmentOptions>
    );
};
